module.exports = __webpack_public_path__ + "img/promptpay-qr.ff5f4fcb.png";